import React, { useEffect, useState } from "react";

export default function InstallPrompt() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showInstall, setShowInstall] = useState(false);
    const [closing, setClosing] = useState(false);

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowInstall(true);
        };
        const installedHandler = () => {
            setShowInstall(false);
            setDeferredPrompt(null);
        };
        window.addEventListener("beforeinstallprompt", handler);
        window.addEventListener("appinstalled", installedHandler);
        return () => {
            window.removeEventListener("beforeinstallprompt", handler);
            window.removeEventListener("appinstalled", installedHandler);
        };
    }, []);

    const close = () => {
        setClosing(true);
        setTimeout(() => {
            setShowInstall(false);
            setClosing(false);
        }, 200);
    };

    const handleInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log("User response:", outcome);
        setDeferredPrompt(null);
        close();
    };

    if (!showInstall) return null;

    return (
        <>
            <style>{`
        @keyframes ipIn  { from { opacity: 0; transform: translate(-50%, 8px); } to { opacity: 1; transform: translate(-50%, 0); } }
        @keyframes ipOut { from { opacity: 1; transform: translate(-50%, 0); }   to { opacity: 0; transform: translate(-50%, 8px); } }

        .ip {
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          width: calc(100% - 50px);
          max-width: 400px;
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 12px 12px 12px 16px;
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 20px -4px rgba(0, 0, 0, 0.08);
          z-index: 999999;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          animation: ipIn 0.25s ease-out;
        }
        .ip.closing { animation: ipOut 0.2s ease-in forwards; }

        .ip-text {
          flex: 1;
          min-width: 0;
          font-size: 13.5px;
          line-height: 1.4;
          color: #111827;
          margin: 0;
        }
        .ip-text span {
          display: block;
          color: #6b7280;
          font-size: 12px;
          margin-top: 2px;
        }

        .ip-install {
          flex-shrink: 0;
          padding: 8px 14px;
          font-size: 13px;
          font-weight: 500;
          color: #ffffff;
          background: linear-gradient(90deg, rgb(0, 51, 136), rgb(0, 85, 203));
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.15s ease;
          font-family: inherit;
        }
        .ip-install:hover { background: #1f2937; }
        .ip-install:active { background: #000000; }

        .ip-close {
          flex-shrink: 0;
          width: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: transparent;
          border: none;
          border-radius: 6px;
          color: #9ca3af;
          font-size: 18px;
          line-height: 1;
          cursor: pointer;
          transition: color 0.15s ease, background 0.15s ease;
          padding: 0;
        }
        .ip-close:hover { color: #111827; background: #f3f4f6; }

        @media (max-width: 420px) {
          .ip { padding: 12px; gap: 10px; }
          .ip-text { font-size: 13px; }
          .ip-install { padding: 8px 12px; font-size: 12.5px; }
        }
      `}</style>

            <div
                className={`ip ${closing ? "closing" : ""}`}
                role="dialog"
                aria-live="polite"
                aria-label="Install aplikasi"
            >
                <p className="ip-text">
                    Install aplikasi
                    <span>Akses cepat dari layar utama</span>
                </p>

                <button className="ip-install" onClick={handleInstall}>
                    Install
                </button>

                <button
                    className="ip-close"
                    onClick={close}
                    aria-label="Tutup"
                >
                    ×
                </button>
            </div>
        </>
    );
}